import { useCallback } from 'react';

import { TinyMCE } from '../types';
import { useContentController } from '../../../../../hooks/form';
import { useDynamicContentContext } from '../../../../../contexts';
import { getContentFromEditor } from '../utils/getContentFromEditor';
import { useEditorContentChangeEffect } from './useEditorContentChangeEffect';

export const useSetNewContentEffect = (editor: TinyMCE | null) => {
  const {
    field: { value: contentFromContext = '', onChange },
  } = useContentController();
  const { contentType } = useDynamicContentContext();

  const sync = useCallback(() => {
    const contentFromEditor = getContentFromEditor(editor, contentType);
    const isContextOutOfDate = contentFromContext !== contentFromEditor;

    if (isContextOutOfDate) {
      onChange({
        target: { value: contentFromEditor },
      });
    }
  }, [editor, contentType, contentFromContext, onChange]);

  useEditorContentChangeEffect(sync, editor);
};
